import { render } from "./CanvasFirme.vue?vue&type=template&id=42cf9c15&scoped=true"
import script from "./CanvasFirme.vue?vue&type=script&lang=js"
export * from "./CanvasFirme.vue?vue&type=script&lang=js"

import "./CanvasFirme.vue?vue&type=style&index=0&id=42cf9c15&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_assitech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cf9c15"]])

export default __exports__